import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';

export interface BenefitProgram {
  id: number;
  userCode: string;
  userName?: string;
  description: string;
  expiredAt: string;
  avatarUrl?: string | null;
  createDate?: string | null;
  lastUpdDate?: string | null;
  status?: any;
  preview?: string;
  previewType?: string;
}

@Injectable({
  providedIn: 'root'
})
export class BenefitService {
  private readonly endpoints = {
    all: 'afterSalesProgram/all',
    save: 'afterSalesProgram/save',
    delete: 'afterSalesProgram/delete',
    updateStatus: 'afterSalesProgram/updateStatus'
  } as const;

  constructor(private api: ApiService) { }

  getAllPrograms(): Observable<any> {
    return this.api.get<any>(this.endpoints.all);
  }

  saveProgram(data: Partial<BenefitProgram>): Observable<BenefitProgram> {
    return this.api.post<BenefitProgram>(this.endpoints.save, data);
  }

  deleteProgram(data: Partial<BenefitProgram>): Observable<any> {
    return this.api.post<any>(this.endpoints.delete, data);
  }

  updateStatus(data: Partial<BenefitProgram>): Observable<any> {
    return this.api.post<any>(this.endpoints.updateStatus, data);
  }

    getAllOptionUser(): Observable<any> {
    return this.api.get<any>('user/getAllOptionUser', null);
  }

    getAfterSalesProgram(): Observable<any> {
    return this.api.get<any>('afterSalesProgram/getAfterSalesProgram', null);
  }
}
